module.exports = __webpack_public_path__ + "images/icons/icon-step-payment-f45392a9.svg";